import { CountResponse, createResetLimitMutation, WalletDetailedWithAccountId } from 'shared/api';
import { ConfirmModalModel, createConfirmModalModel, declareModalData } from 'shared/lib';

export type ResetLimitModel = ConfirmModalModel<WalletDetailedWithAccountId, number, CountResponse>;

export const createResetLimitModel = (): ResetLimitModel => {
	const resetLimitMutation = createResetLimitMutation();

	const model = createConfirmModalModel({
		modalData: declareModalData<WalletDetailedWithAccountId>(),
		mutation: resetLimitMutation,
		mapModalData: ({ id }) => id,
		successMessageKey: 'reset-limit.success',
	});

	return model;
};
